//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const UserCircle = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="UserCircle"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21706_270)">
            <path
              d="M8 14.9987C11.866 14.9987 15 11.8647 15 7.99875C15 4.13276 11.866 0.998749 8 0.998749C4.13401 0.998749 1 4.13276 1 7.99875C1 11.8647 4.13401 14.9987 8 14.9987Z"
              stroke="currentColor"
              strokeWidth={1.33}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.5 12.5642C3.68857 11.9366 4.07443 11.3865 4.60033 10.9955C5.12623 10.6045 5.76417 10.3934 6.41949 10.3936H9.46698C10.1232 10.3934 10.7619 10.6049 11.2882 10.9968C11.8144 11.3887 12.2002 11.94 12.388 12.5687M10.2288 5.82236C10.2288 7.08467 9.20553 8.10798 7.94322 8.10798C6.68091 8.10798 5.6576 7.08467 5.6576 5.82236C5.6576 4.56005 6.68091 3.53674 7.94322 3.53674C9.20553 3.53674 10.2288 4.56005 10.2288 5.82236Z"
              stroke="currentColor"
              strokeWidth={1.52374}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21706_270">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
